<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="data-list-list-view" class="data-list-container">
    <div class="mt-6 flex px-6">
      <h2>Encuesta de satisfacción</h2>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">       
        <div id="user-data">
          <div v-if="this.$route.params.nameCompany === this.nameCompanyCVC">
            
            <vx-card :title="titleCard" class="mb-base">

              <div class="mt-5">
                <p class="font-medium"> {{ pregunta1 }} </p>
                <ul class="centerx mt-6 mb-2 ml-3">
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta1" vs-value="1.1">Pesimo</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta1" vs-value="2.1">Malo</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta1" vs-value="3.1">Regular</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta1" vs-value="4.1">Bueno</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta1" vs-value="5.1">Excelente</vs-radio>
                  </li>
                </ul>
                <span
                  class="text-danger text-sm ml-3"
                  v-show="
                    errors.has('respuesta1') || formerr.includes('respuesta1')
                  "
                  >Por favor seleccione la respuesta</span
                >
              </div>

              <div class="mt-10">
                <p class="font-medium"> {{ pregunta2 }} </p>
                <ul class="centerx mt-6 mb-2 ml-3">
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta2" vs-value="1.2">Pesimo</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta2" vs-value="2.2">Malo</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta2" vs-value="3.2">Regular</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta2" vs-value="4.2">Bueno</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta2" vs-value="5.2">Excelente</vs-radio>
                  </li>
                </ul>
                <span
                  class="text-danger text-sm"
                  v-show="
                    errors.has('respuesta2') || formerr.includes('respuesta2')
                  "
                  >Por favor seleccione la respuesta</span
                >
              </div>

              <div class="mt-10">
                <p class="font-medium"> {{ pregunta3 }} </p>
                <ul class="centerx mt-6 mb-2 ml-3">
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta3" vs-value="1.3">Pesimo</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta3" vs-value="2.3">Malo</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta3" vs-value="3.3">Regular</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta3" vs-value="4.3">Bueno</vs-radio>
                  </li>
                  <li class="vs-radio-container">
                    <vs-radio v-model="respuesta3" vs-value="5.3">Excelente</vs-radio>
                  </li>
                </ul>
                <span
                  class="text-danger text-sm"
                  v-show="
                    errors.has('respuesta3') || formerr.includes('respuesta3')
                  "
                  >Por favor seleccione la respuesta</span
                >
              </div>
            </vx-card>
          </div>

          <vx-card :title="titleCard" class="mb-base" v-else>

            <div class="mt-5">
              <p class="font-medium"> {{ pregunta1 }} </p>
              <ul class="centerx mt-6 mb-2 ml-3">
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta1" vs-value="1.1">Pesimo</vs-radio>
                </li>
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta1" vs-value="2.1">Malo</vs-radio>
                </li>
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta1" vs-value="3.1">Regular</vs-radio>
                </li>
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta1" vs-value="4.1">Bueno</vs-radio>
                </li>
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta1" vs-value="5.1">Excelente</vs-radio>
                </li>
              </ul>
              <span
                class="text-danger text-sm ml-3"
                v-show="
                  errors.has('respuesta1') || formerr.includes('respuesta1')
                "
                >Por favor seleccione la respuesta</span
              >
            </div>
            
            <!-- <div class="mt-10">
              <p class="font-medium"> {{ pregunta5 }} </p>
              <ul class="centerx mt-4">
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta5" vs-value="1.5">Excelente</vs-radio>
                </li>
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta5" vs-value="2.5">Bueno</vs-radio>
                </li>
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta5" vs-value="3.5">Regular</vs-radio>
                </li>
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta5" vs-value="4.5">Deficiente</vs-radio>
                </li>
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta5" vs-value="5.5">Malo</vs-radio>
                </li>
                <li class="vs-radio-container">
                  <vs-radio v-model="respuesta5" vs-value="6.5">No Aplica</vs-radio>
                </li>
              </ul>
              <span
                class="text-danger text-sm"
                v-show="
                  errors.has('respuesta5') || formerr.includes('respuesta5')
                "
                >Por favor seleccione la respuesta</span
              >
            </div>

            <div class="mt-10">
              <p class="font-medium"> {{ pregunta6 }} </p>
              <vs-textarea
                class="w-full mt-4"
                v-model="observaciones"
                v-validate="'required'"
                name="observaciones"
              />
            </div> -->

          </vx-card>

          <div class="vx-col w-full flex mb-10" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-send"
              class="mr-4"
              @click="actionSaveData"
              >Enviar</vs-button
            >
            <!-- <vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              @click="closeSidebar"
              >Cancelar</vs-button
            > -->
          </div>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import FormulariosModule from '@/store/formularios-module/moduleDataList.js'
import {companiesEnums} from '../../config/companies.js'

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      formerr: [], // Crear => true/Modificar => false
      titleCard : 'De acuerdo con su experiencia:',
      pregunta1 : '1. ¿Cómo califica usted la atención recibida?',
      pregunta2 : '2. ¿Considera que su inconveniente o problema fue solucionado?',
      pregunta3 : '3. ¿La Atención recibida fue oportuna?',
      pregunta4 : '4. ',
      pregunta5 : '5. ',
      pregunta6 : '6. ',   
      // titleCard : 'De acuerdo con su experiencia, ¿Cómo califica usted la atención recibida?', // 'Califique su nivel de satisfacción en estos aspectos.',
      // pregunta1 : '1. Actitud de servicio:',
      // pregunta2 : '2. La rapidez para solucionar su requerimiento, una vez se ha comunicado:',
      // pregunta3 : '3. Conocimientos técnicos o de proceso y experiencia de los analistas:',
      // pregunta4 : '4. Solución satisfactoria a los requerimientos reportados:',
      // pregunta5 : '5. En general qué tan satisfecho se encuentra con el servicio prestado por la mesa de servicio:',
      // pregunta6 : '6. Observaciones:',     
      respuesta1: '',
      respuesta2: '',
      respuesta3: '',
      respuesta4: '',
      respuesta5: '',
      observaciones: '',
      nameCompanyCVC: '',
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  created () {
    if (!FormulariosModule.isRegistered) {
      this.$store.registerModule('FormulariosModule', FormulariosModule)
      FormulariosModule.isRegistered = true
    }

    this.nameCompanyCVC = companiesEnums.CVC
  },
  watch: {
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.formerr.length <= 0
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    actionSaveData () {

      // console.log('nameCompany', this.$route.params.nameCompany)
      // console.log('idRequest', this.$route.params.idRequest)

      this.formerr = []

      if (this.$route.params.nameCompany === this.nameCompanyCVC) {
        if (
          this.respuesta1 === null ||
          this.respuesta1 === undefined ||
          this.respuesta1 === ''
        ) {
          this.formerr.push('respuesta1')
        }
        if (
          this.respuesta2 === null ||
        this.respuesta2 === undefined ||
        this.respuesta2 === ''
        ) {
          this.formerr.push('respuesta2')
        }

        if (
          this.respuesta3 === null ||
        this.respuesta3 === undefined ||
        this.respuesta3 === ''
        ) {
          this.formerr.push('respuesta3')
        }
      } else if (
        this.respuesta1 === null ||
          this.respuesta1 === undefined ||
          this.respuesta1 === ''
      ) {
        this.formerr.push('respuesta1')
      }
      
      
      if (this.validateForm) {

        const idRequest = this.$route.params.idRequest

        let formDataTMP = []

        if (this.$route.params.nameCompany === this.nameCompanyCVC) {
          formDataTMP = [
            {
              id: 1,
              idRequest,
              descripcion: this.pregunta1,
              repuesta: Math.trunc(this.respuesta1)
            },
            {
              id: 2,
              idRequest,
              descripcion: this.pregunta2,
              repuesta: Math.trunc(this.respuesta2)
            },
            {
              id: 3,
              idRequest,
              descripcion: this.pregunta3,
              repuesta: Math.trunc(this.respuesta3)
            }
          ]
        } else {
          formDataTMP = [
            {
              id: 1,
              idRequest,
              descripcion: this.pregunta1,
              repuesta: Math.trunc(this.respuesta1)
            }
          ]
        }

        //console.log('List', formDataTMP)
        this.sendFormData(formDataTMP)
      }
    },
    sendFormData (formDataTMP) {
      this.$vs.loading()

      console.log('Enviando datos a crear: ', formDataTMP)

      this.$store
        .dispatch('FormulariosModule/sendFormData', formDataTMP)
        .then((response) => {
          this.$vs.loading.close()

          if (response) {
            if (response.v_code === 0) {
              this.initValues()

              this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: 'Aviso',
                text: response.v_errm,
                accept: this.acceptAlert
              })
            } else {
              this.$vs.dialog({
                color: 'danger',
                title: 'Error',
                text: response.v_errm,
                acceptText: 'Aceptar'
              })
            }
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No se pudo crear el registro de los datos.',
              acceptText: 'Aceptar'
            })
          }
        })
        .catch((ex) => {
          this.$vs.loading.close()
          if (
            ex.data !== null &&
            ex.data !== undefined &&
            ex.data.nuOK !== -1
          ) {
            this.$vs.dialog({
              color: 'warning',
              title: 'Información',
              text: ex.data.errorDesc,
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No es posible consultar la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    },
    acceptAlert () {
      this.$router.push(`/${this.$route.params.nameCompany}`).catch(() => {})
    },
    initValues () {
      this.formerr = []  
      this.respuesta1 = ''
      this.respuesta2 = ''
      this.respuesta3 = ''
      this.respuesta4 = ''
      this.respuesta5 = ''
      this.observaciones = ''
    },    
    closeSidebar () {
      this.$emit('closeSidebar')
      this.$validator.reset()
      this.initValues()
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 51001;
  }

  ::v-deep .vs-sidebar {
    z-index: 51001;
    width: 90%;
    height: 95%;
    max-width: 1000vw;
    max-height: 1000vw;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0; 
    right: 0; 
    margin-top: auto; 
    margin-bottom: auto; 
    margin-left: auto; 
    margin-right: auto; 

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: 90%;

  &:not(.ps) {
    overflow-y: auto;
  }
}

.vs-radio-container {
  margin-top: .3rem;
}
</style>
